import { NgModule } from '@angular/core';
import { SidebarNewComponent } from './sidebar-new/sidebar-new.component';

@NgModule({
    imports: [ SidebarNewComponent ],
    exports: [ SidebarNewComponent ]
})

export class SidebarModule {}
